/**
 * Shared constants for decorative map illustration SVGs.
 *
 * Used by OnboardingMapIllustration & the share gate / error illustrations to
 * keep opacity and color theming consistent across all illustration variants.
 */

export interface RoadOpacity {
  wide: number;
  edge: number;
  dash: number;
}

export interface PinOpacity {
  outer: number;
  inner: number;
}

export const ROAD_OPACITY_DARK: RoadOpacity = {
  wide: 0.04,
  edge: 0.12,
  dash: 0.2,
};
export const ROAD_OPACITY_LIGHT: RoadOpacity = {
  wide: 0.06,
  edge: 0.12,
  dash: 0.5,
};
export const PIN_OPACITY_DARK: PinOpacity = { outer: 0.05, inner: 0.12 };
export const PIN_OPACITY_LIGHT: PinOpacity = { outer: 0.06, inner: 0.15 };
